// The devices in /shares' drawer: each machine logged in with byj-share, as
// the relay says it — its name, when it was last seen and its byj-share
// version, each on a line of its own, exactly as sent — most recently seen
// first, each with its Revoke. Under them, how another device is added.
import type { Device } from "../api";
import { t, when } from "../i18n";
import { CopyButton } from "./Copy";

const DeviceIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="4" y="5" width="16" height="11" rx="1.5" />
    <path d="M2 19h20" />
  </svg>
);

function LoginHint() {
  return (
    <p className="device-add muted small">
      {t("shares:addDeviceBefore")} <code>{t("shares:loginCommand")}</code> {t("shares:addDeviceAfter")} <CopyButton text={t("shares:loginCommand")} />
    </p>
  );
}

export function DeviceList({ devices, onRevoke }: { devices: Device[] | null; onRevoke: (d: Device) => void }) {
  if (devices === null) return <p className="muted">{t("common:loading")}</p>;
  const newest = devices.slice().sort((a, b) => Date.parse(b.last_seen) - Date.parse(a.last_seen));
  return (
    <>
      {devices.length === 0 ? (
        <p className="muted">{t("shares:noDevices")}</p>
      ) : (
        <ul className="devices">
          {newest.map((d) => (
            <li key={d.id} className="device-row">
              <span className="kind-box" aria-hidden="true">
                <DeviceIcon />
              </span>
              <div className="device-main">
                <strong className="device-name">{d.name}</strong>
                <dl className="device-facts">
                  <dt>{t("shares:lastSeenLabel")}</dt>
                  <dd>{when(d.last_seen)}</dd>
                  <dt>byj-share</dt>
                  <dd>
                    <code>{d.sidecar_version}</code>
                  </dd>
                </dl>
              </div>
              <button className="small danger" onClick={() => onRevoke(d)}>
                {t("shares:revoke")}
              </button>
            </li>
          ))}
        </ul>
      )}
      <LoginHint />
    </>
  );
}
